import React from "react";

export default function CreditsModal({ children }) {
  return (
    <div
      className="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 bg-overlay" />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <div className="relative my-4 w-full max-w-lg rounded-2xl bg-white p-6 text-left shadow-[0_0_0_1px_var(--hairline)]">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
